import React from 'react'
import PropTypes from 'prop-types'
import { PieChart, Pie, Cell } from 'recharts'
import css from './circle-chart.css'

const CircleChart = ({
  data,
  height,
  width,
  primaryColor,
  secondaryColor,
  innerRadius,
  outerRadius,
  children,
}) => (
  <div className={css.wrapper}>
    <div className={css.chart}>
      <PieChart width={width} height={height}>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          startAngle={90}
          endAngle={-270}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          paddingAngle={0}
        >
          <Cell fill={primaryColor} />
          <Cell fill={secondaryColor} />
        </Pie>
      </PieChart>
    </div>
    {children && <div className={css.chart}>{children[0]}</div>}
    {children && <div className={css.label}>{children[1]}</div>}
  </div>
)

CircleChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.number })),
  primaryColor: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  innerRadius: PropTypes.number.isRequired,
  outerRadius: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default CircleChart



// WEBPACK FOOTER //
// ./src/components/Dashboard/CircleChart.js